<template>
  <f7-list-group>
    <f7-list-item group-title>
      <div class="weekday-title">
        <span>
          {{ weekday }}
          <span v-if="!businessHours || businessHours.length === 0">(公休)</span>
        </span>
        <font-awesome-icon slot="after" icon="plus" @click="onCreateBusinessHour"/>
      </div>
    </f7-list-item>
    <business-hour-list-item
      v-for="(businessHour, index) in businessHours"
      :key="`sevice-hour-${index}`"
      :menuVariation="menuVariation"
      :weekdayIndex="weekdayIndex"
      :businessHourIndex="index"
      :businessHours="businessHours"
      @delete="deleteBusinessHour({ menuVariation, weekdayIndex, index })"/>
  </f7-list-group>
</template>

<script>
import BusinessHourListItem from './BusinessHourListItem'
import { mapActions } from 'vuex'

export default {
  components: {
    BusinessHourListItem
  },
  props: ['menuVariation', 'weekday', 'weekdayIndex', 'businessHours'],
  methods: {
    ...mapActions('menuModule', ['createBusinessHour', 'deleteBusinessHour']),
    onCreateBusinessHour () { this.createBusinessHour({ menuVariation: this.menuVariation, weekdayIndex: this.weekdayIndex }) }
  }
}
</script>

<style lang="scss" scoped>

.weekday-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>
